export const emitZap = (el: HTMLButtonElement, x: number, y: number): void => {
  el.style.setProperty('--zap-x', `${x}px`)
  el.style.setProperty('--zap-y', `${y}px`)
  const ripple = document.createElement('span')
  ripple.className = 'zapBtn__ripple'
  el.appendChild(ripple)
  el.classList.add('is-zapping')
  const cleanup = () => {
    ripple.remove()
    el.classList.remove('is-zapping')
  }
  ripple.addEventListener('animationend', cleanup, { once: true })
  window.setTimeout(cleanup, 700)
}
